/** The four authentication headers of a paid call (D64) and the two routing headers (CONTRACT.md 0.3). */
export const H = {
  client: "X-Service-Client",
  identity: "X-Service-Identity",
  call: "X-Service-Call",
  signature: "X-Service-Signature",
  callback: "X-Service-Callback",
  close: "X-Service-Close",
  receipt: "X-Service-Receipt",
  wallet: "X-Wallet",
  walletTimestamp: "X-Wallet-Timestamp",
  walletSignature: "X-Wallet-Signature",
} as const;

/** The body of `X-Service-Receipt` on a paid answer. */
export interface ReceiptHeader {
  call: string;
  actual: string;
  credits: string;
  tx: string;
}

export function encodeReceiptHeader(r: ReceiptHeader): string {
  return JSON.stringify({ call: r.call, actual: r.actual, credits: r.credits, tx: r.tx });
}

export function decodeReceiptHeader(value: string | null): ReceiptHeader | null {
  if (!value) return null;
  try {
    const o = JSON.parse(value) as Partial<ReceiptHeader>;
    if (typeof o.call !== "string" || typeof o.actual !== "string") return null;
    return { call: o.call, actual: o.actual, credits: o.credits ?? "0", tx: o.tx ?? "" };
  } catch {
    return null;
  }
}
